import { setAppType } from "@funded-here-interface/common/src/constant/appType";
import ErrorBoundary from "@funded-here-interface/common/src/dashboard/components/ErrorBoundry";

import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";

setAppType("admin");

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
